import React from "react";
import { Route } from "react-router-dom";
import { ProductoAliadoMainScreen } from "./ProductoAliadoMainScreen";
import { ListadoPreciosScreen } from "./ListadoPrecios/ListadoPreciosScreen";
import { ConfiguracionImagenesScreen } from "./ConfiguracionImagenes/ConfiguracionImagenesScreen";
import { ConfiguracionListadoPreciosScreen } from "./ConfiguracionListado/ConfiguracionListadoPreciosScreen";

export const ProductoAliadoListado = () => {
    return (
        <div className="main-container">
            <Route
                path="/ProductoAliado/Main"
                component={() => <ProductoAliadoMainScreen />}
            />
            <Route
                path="/ProductoAliado/ConfiguracionListadoPrecios"
                component={() => <ConfiguracionListadoPreciosScreen />}
            />
            <Route
                path="/ProductoAliado/ListadoPrecios"
                component={() => <ListadoPreciosScreen />}
            />
            <Route
                path="/ProductoAliado/ConfiguracionImagenesModelo"
                component={() => <ConfiguracionImagenesScreen />}
            />
        </div>
    );
}; 
